<template>
  <div class="home-content">
    <div class="head-select">
      <el-input
        v-model="searchval"
        placeholder="请输入生产组名称等"
        class="search-input"
      ></el-input>
      <el-button type="primary" class="search-button" @click="search">
        <img src="@/assets/icon/search.png" alt="" class="button-icon" />
        查询
      </el-button>
      <el-button type="primary" class="add-button" @click="add">
        新增
      </el-button>
      <el-button type="danger" class="del-button" @click="delMulti">
        删除
      </el-button>
    </div>
    <div class="machine-content">
      <div class="list-con">
        <el-table
          ref="filterTable"
          :data="tabelData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            :prop="item.key"
            :label="item.label"
            v-for="item in dataSource"
            :key="item.key"
          >
            <template slot-scope="scope">
              <div class="text" v-if="!slotmap.includes(item.key)">
                {{ scope.row[item.key]?scope.row[item.key]:"--" }}
              </div>
              <div class="text" v-else-if="item.key == 'product'">
                {{ scope.row[item.key]["name"] }}
              </div>
              <div class="text" v-else-if="item.key == 'department'">
                <span v-if="scope.row[item.key]">{{ scope.row[item.key]["name"] }}</span>
                <span v-if="!scope.row[item.key]">--</span>
              </div>    
              <div v-else-if="item.key == 'menu'" class="tab-menu">
                <div class="edit" @click="edit(scope.row)">编辑</div>
                <div class="line"></div>
                <div class="delbtn" @click="delSingle(scope.row)">删除</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="numdata"
        style="margin-top: 30px; float: right; margin-right: 60px"
        :current-page="current_page"
        :page-size="page_size"
        @current-change="handleCurrentChange"
        @prev-click="handleCurrentChange_prev"
        @next-click="handleCurrentChange_next"
      >
      </el-pagination>      
    </div>
    <el-dialog
      :visible.sync="addvisible"
      :modal-append-to-body="true"
      custom-class="edit-dialog"
      @close="dialogclose"
      :destroy-on-close="true" 
      :close-on-click-modal ="false"
      width="720px"
    >
      <div slot="title">{{formData.id>0?"编辑":"新增"}}</div>
      <div class="edit-content">
        <div class="edit-item">
          <div class="text">生产组名</div>
          <el-input
            class="edit-input"
            v-model="formData.name"
            placeholder="请输入名称"
          ></el-input>
        </div>    
      </div>
      <div slot="footer">
        <div class="button-group">
          <el-button type="info" size="small" @click="dialogclose"
            >取消</el-button
          >
          <el-button type="primary" size="small" @click="adds"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>  

    <el-dialog
      :visible.sync="addvisible"
      :modal-append-to-body="true"
      custom-class="edit-dialog"
      @close="dialogclose"
      :destroy-on-close="true" 
      :close-on-click-modal ="false"
      width="720px"
    >
      <div slot="title">新增</div>
      <div class="edit-content">
        <div class="edit-item">
          <div class="text">名称</div>
          <el-input
            class="edit-input"
            v-model="formData.name"
            placeholder="请输入名称"
          ></el-input>
        </div>       
      </div>
      <div slot="footer">
        <div class="button-group">
          <el-button type="info" size="small" @click="dialogclose"
            >取消</el-button
          >
          <el-button type="primary" size="small" @click="adds"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>  
  </div>
</template>

<script>
import { delGroups,editGroups,getGrouupLists,addGroups } from "../../api/index";
export default {
  data() {
    return {
      activeName: "first",
      timer1: "",
      searchval: "",
      dataSource: [
        { label: "ID", key: "id" },
        { label: "名称", key: "name" },
        //{ label: "所属生产组", key: "department" },
        { label: "操作", key: "menu" },
      ],
      tabelData: [],
      slotmap: ["menu","product","department"],
      numdata: 0,
      current_page: 1,
      page_size:10,
      addvisible:false,
      formData:{
        id:0,
        name:"",
      },
      delList:[],//删除列表
      searchStr:[
        {field:"name",val:"",operator:"like"}
      ],//删除
    };
  },
  methods: {
    delMulti(){
      if(this.delList.length==0){
        this.$message.warning("请选择要删除的生产组!");
        return;
      }
      this.$confirm(
        '确认删除选择的生产组吗?',
        '警告',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        var forms={
          ids:this.delList,
        }
        delGroups(forms).then(res => {	
          if(res.code==1){
            //_this.itemContentProgressList[index].status=_this.itemContentProgressList[index].tempStatus;
            this.$message.success(res.msg);
            this.delList=[];
            this.getData();
          }else{
            this.$message.warning("删除失败!");
          }					
        });
      }).catch((err) => {
        Message.warning('取消操作');
      }) 
    },    
    delSingle(row){
      this.$confirm(
        '确认删除该生产组吗?',
        '警告',
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        var forms={
          ids:[row.id],
        }
        delGroups(forms).then(res => {	
          if(res.code==1){
            //_this.itemContentProgressList[index].status=_this.itemContentProgressList[index].tempStatus;
            this.$message.success(res.msg);
            this.getData();
          }else{
            this.$message.warning("删除失败!");
          }					
        });
      }).catch((err) => {
        Message.warning('取消操作');
      }) 
    },
    dialogclose(){
      this.addvisible=false;
    },
    //添加修改生产组
    adds(){
      if(!this.formData.name){
        this.$message.warning("名称不能为空!");
        return;
      }
      if(this.formData.id==0){
        addGroups(this.formData)
          .then((res) => {
            if (res.code == 1) {
              this.addvisible = false;
              this.$message.success("添加成功!");
              this.getData();
            } else {
              this.$message.error("添加失败");
            }

            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          }); 
      }else{
        editGroups(this.formData)
          .then((res) => {
            if (res.code == 1) {
              this.addvisible = false;
              this.$message.success("修改成功!");
              this.getData();
            } else {
              this.$message.error(res.msg);
              //this.$message.error("编辑失败");
            }

            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          }); 
      }                     
    },
    handleCurrentChange_next() {
      this.current_page += 1;
    },
    handleCurrentChange_prev() {
      this.current_page -= 1;
    },
    handleCurrentChange(val) {
      this.current_page=val;
      this.getData();
    },
    getData() {
      let params={};
      if(this.searchval){
        params = {
          limit: this.page_size,
          page: this.current_page,
          "search[0][field]": "name",
          "search[0][val]": this.searchval,
          "search[0][operator]": "LIKE",   
        };
      }else{
        params = {
          limit: this.page_size,
          page: this.current_page,
        };
      }

      getGrouupLists(params)
        .then((res) => {
          if (res.code == 1) {
            this.tabelData = res.data.list;
            console.log(res);
            this.numdata = res.data.total;
          } else {
            this.$message.error("数据获取失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    search() {
      this.current_page=1;
      this.getData();
    },
    handleClick(active) {},
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.delList=[];
      for(var i=0;i<this.multipleSelection.length;i++){
        this.delList.push(this.multipleSelection[i].id);
      }
      
    },
    add() {
      this.addvisible=true;
      this.formData={
        id:0,
        name:"",
      };
    },
    del() {},
    edit(row) {
      this.formData={
        id:row.id,
        name:row.name,
      }
      this.addvisible=true;
      console.log("rows===="+JSON.stringify(row));
      
    },
    itemdel() {},
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.home-content {
  height: calc(100% - 64px);
  .head-select {
    padding: 24px 0 24px 42px;
    display: flex;
    align-items: center;
    .el-date-editor {
      margin-left: 16px;
      width: 185px;
    }
  }
  .search-input {
    width: 245px;
  }
  .search-select {
    width: 185px;
    margin-left: 16px;
  }
  .search-button {
    margin-left: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #fefeff;
    line-height: 14px;
    padding: 10px 20px;
    .button-icon {
      margin-right: 10px;
      width: 15.5px;
      height: 15.5px;
    }
  }
  .add-button {
    margin-left: auto;
  }
  .del-button {
    margin-right: 125px;
  }
  .machine-content {
    padding: 0 28px;
    height: calc(100% - 88px);
    background: #fff;
  }
  .line {
    width: 1px;
    height: 12px;
    background: #e6e6e6;
  }
  .tab-menu {
    display: flex;
    align-items: center;
    column-gap: 12px;
  }
  .edit {
    cursor: pointer;
    color: #507af9;
  }
  .delbtn {
    cursor: pointer;
    color: #f95050;
  }
}
</style>
<style lang="scss">
.list-con {
  padding-top: 30px;
  .el-table__header-wrapper {
    th {
      background: #fafafa;
      color: #0c0c0c;
    }
  }
}
</style>